/* INTERHOUSE - PARDUODAMA */
(function () {
  "use strict";
  document.querySelectorAll(".ihp .num").forEach(function (el) {
    var n = parseFloat(el.textContent.replace(/\s/g, "").replace(",", "."));
    if (isNaN(n)) return;
    el.textContent = Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  });

  var stbar = document.querySelector(".ihp [data-stbar]");
  if (stbar) {
    stbar.querySelectorAll(".chip").forEach(function (c) {
      c.addEventListener("click", function () {
        stbar.querySelectorAll(".chip").forEach(function (x) { x.setAttribute("aria-pressed", "false"); });
        c.setAttribute("aria-pressed", "true");
        var f = c.dataset.st;
        document.querySelectorAll(".ihp .cards .card").forEach(function (el) {
          el.style.display = (f === "all" || el.dataset.st === f) ? "" : "none";
        });
      });
    });
  }

  var box = document.getElementById("ihp-gal");
  if (!box) return;
  var items = [].slice.call(box.querySelectorAll(".gi"));

  function layout() {
    var W = box.clientWidth;
    if (!W) return;
    var vis = items.filter(function (e) { return e.style.display !== "none"; });
    var G = W < 720 ? 10 : 14;
    var mobile = W < 560;
    var targetH = W < 900 ? 260 : 330;
    var row = [], sum = 0;
    function place(h) {
      row.forEach(function (it) {
        it.el.style.width = Math.floor(it.ar * h) + "px";
        it.el.style.height = Math.round(h) + "px";
      });
      row = []; sum = 0;
    }
    vis.forEach(function (el, i) {
      var ar = parseFloat(el.dataset.ar) || 1.5;
      if (mobile || i === 0) {
        if (row.length) place((W - G * (row.length - 1)) / sum);
        el.style.width = W + "px";
        el.style.height = Math.round(Math.min(W / ar, mobile ? 99999 : 620)) + "px";
        return;
      }
      row.push({ el: el, ar: ar }); sum += ar;
      var h = (W - G * (row.length - 1)) / sum;
      if (h <= targetH) place(h);
    });
    if (row.length) place(Math.min((W - G * (row.length - 1)) / sum, targetH * 1.15));
  }

  var bar = document.querySelector(".ihp [data-galbar]");
  if (bar) {
    var cnt = bar.querySelector(".gal-count");
    var apply = function (f) {
      var n = 0;
      items.forEach(function (el) {
        var show = (f === "all" || el.dataset.g === f);
        el.style.display = show ? "" : "none";
        if (show) n++;
      });
      if (cnt) cnt.textContent = n + " nuotr.";
      layout();
    };
    bar.querySelectorAll(".chip").forEach(function (c) {
      c.addEventListener("click", function () {
        bar.querySelectorAll(".chip").forEach(function (x) { x.setAttribute("aria-pressed", "false"); });
        c.setAttribute("aria-pressed", "true");
        apply(c.dataset.f);
      });
    });
    apply("all");
  } else { layout(); }

  var rt;
  addEventListener("resize", function () { clearTimeout(rt); rt = setTimeout(layout, 120); });
  addEventListener("load", layout);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(layout);

  var lb = document.getElementById("ihp-lb");
  if (!lb) return;
  var lbimg = lb.querySelector(".lb-img"), lbcap = lb.querySelector(".lb-cap"), lbnum = lb.querySelector(".lb-num");
  var cur = [], idx = 0;
  function openLb(el) {
    cur = items.filter(function (e) { return e.style.display !== "none"; });
    idx = Math.max(0, cur.indexOf(el));
    lb.classList.add("on");
    document.body.style.overflow = "hidden";
    show();
  }
  function show() {
    var el = cur[idx];
    lbimg.src = el.dataset.full;
    lbimg.alt = el.dataset.cap || "";
    lbcap.textContent = el.dataset.cap || "";
    lbnum.textContent = (idx + 1) + " / " + cur.length;
  }
  function closeLb() { lb.classList.remove("on"); document.body.style.overflow = ""; }
  function step(d) { idx = (idx + d + cur.length) % cur.length; show(); }
  items.forEach(function (el) {
    el.addEventListener("click", function () { openLb(el); });
    el.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") { e.preventDefault(); openLb(el); }
    });
  });
  lb.querySelector(".lb-x").onclick = closeLb;
  lb.querySelector(".lb-prev").onclick = function (e) { e.stopPropagation(); step(-1); };
  lb.querySelector(".lb-next").onclick = function (e) { e.stopPropagation(); step(1); };
  lb.addEventListener("click", function (e) {
    if (e.target === lb || e.target.classList.contains("lb-stage")) closeLb();
  });
  document.addEventListener("keydown", function (e) {
    if (!lb.classList.contains("on")) return;
    if (e.key === "Escape") closeLb();
    if (e.key === "ArrowLeft") step(-1);
    if (e.key === "ArrowRight") step(1);
  });
  var tx = 0;
  lb.addEventListener("touchstart", function (e) { tx = e.changedTouches[0].clientX; }, { passive: true });
  lb.addEventListener("touchend", function (e) {
    var d = e.changedTouches[0].clientX - tx;
    if (Math.abs(d) > 50) step(d < 0 ? 1 : -1);
  }, { passive: true });

  document.querySelectorAll(".ihp .slot").forEach(function (s) {
    s.addEventListener("click", function () {
      document.querySelectorAll(".ihp .slot").forEach(function (x) { x.setAttribute("aria-pressed", "false"); });
      s.setAttribute("aria-pressed", "true");
      var h = document.getElementById("ihp-slot");
      if (h) h.value = s.textContent.trim();
    });
  });
})();
